(function () {
  'use strict';

  angular.module('MktzapApp.Factories')
    .factory('CompanyService', CompanyService);

  CompanyService.$inject = ['$resource'];

  function CompanyService ($resource) {
    return $resource(apiUrl + '/companies/:id', { id: '@id' }, {
      channels: { url: apiUrl + '/channels/company/:id', method: 'GET', params: {}, isArray: true },
      all: { method: 'GET', params: {}, isArray: true },
      create: { method: 'POST', params: {}, isArray: false },
      update: { method: 'POST', params: { _method: 'PATCH' }, isArray: false },
      saveMetadata: { url: apiUrl + '/company-metadata', method: 'POST', params: { _method: 'PATCH' }, isArray: false },
      updateMetadataDefinition: { url: apiUrl + '/contact-metadata-definition', method: 'POST', params: { _method: 'PATCH' }, isArray: false },
      loadMetadataDefinition: { url: apiUrl + '/contact-metadata-definition', method: 'GET', params: {}, isArray: true },
      saveClassificationConfig: { url: apiUrl + '/company-classification-config', method: 'POST', params: { _method: 'PATCH' }, isArray: false },
      loadMetadata: { url: apiUrl + '/company-metadata', method: 'GET', params: {}, isArray: false },
      getcompanies: { url: apiUrl + '/getcompanies/:id', method: 'GET', params: {}, isArray: true },
      find: { method: 'GET', params: {}, isArray: false },
      findForChannel: { url: apiUrl + '/companies-channels/:type', method: 'GET', params: {}, isArray: false },
      findOne: { method: 'GET', params: {}, isArray: true },
      findCompanyForChannel: { method: 'GET', params: {}, isArray: true },
      saveAttendanceRules: { url: apiUrl + '/company-attendance-rules', method: 'POST', params: {}, isArray: false },
      allSectors: { url: apiUrl + '/company-get-sectors', method: 'GET', params: {}, isArray: true },
      allSectorsByKey: { url: apiUrl + '/company-get-sectors-by-key', method: 'GET', params: {}, isArray: true },
      showField: { url: apiUrl + '/company-show-field', method: 'POST', params: { _method: 'PATCH' }, isArray: false },
      saveSectors: { url: apiUrl + '/company-save-sectors', method: 'POST', params: { _method: 'PATCH' }, isArray: false },
      loadTimezonesByCountry: { url: apiUrl + '/get-time-zones/:initials', method: 'GET', params: {}, isArray: true },
      saveLocalizationConfig: { url: apiUrl + '/save-localization', method: 'POST', params: {}, isArray: false },
      saveData: { url: apiUrl + '/companies-whitelist', method: 'POST', params: {}, isArray: false },
      getContactMetadataDefinition: { url: apiUrl + '/get-cmd', method: 'GET', params: {}, isArray: true },
      loadMetadataKey: { url: apiUrl + '/company-metadata-key/:key', method: 'GET', params: {}, isArray: false },
      store: { url: apiUrl + '/partner-company/partner-company-store', method: 'POST', params: {}, isArray: false },
      updatePartnerCompany: { url: apiUrl + '/partner-company/partner-company-update', method: 'PATCH', params: {}, isArray: false },
      delete: { url: apiUrl + '/partner-company/partner-company-delete', method: 'DELETE', params: {}, isArray: false },
      getPartnerCompaniesById: { url: apiUrl + '/partner-company/get-partner-company', method: 'GET', params: {}, isArray: false },
      getAllPartnerCompanies: { url: apiUrl + '/partner-company/paged', method: 'GET', params: {}, isArray: false },
      filter: { url: apiUrl + '/partner-company/filter', method: 'GET', isArray: false },
      getCompaniesWithProfiles: { url: apiUrl + '/get-companies-with-profiles/:id', method: 'GET', params: {}, isArray: true },
      getCanInactivateProfileControl: { url: apiUrl + '/company-metadata-can-inactivate-profile-control', method: 'GET', params: {}, isArray: false }
    });
  }
})();
